// export class HisActivoFijoVisitanteModel {
//     public hisActivoFijoVisitantePK: HisActivoFijoVisitantePK;
// 	public fechaSalidaActivo:Date;	
//     public sede:string;

//     constructor(hisActivoFijoVisitantePK: HisActivoFijoVisitantePK){
//         this.hisActivoFijoVisitantePK=hisActivoFijoVisitantePK;
//     }
// }

// export class HisActivoFijoVisitantePK {
//     public idActivoFijoVisitante:number;
//     public fechaIngresoActivo:Date;

//     constructor(){}
// }


export class HisActivoFijoVisitanteModel {
    public hisActivoFijoVisitantePK: HisActivoFijoVisitantePK;
	public fechaSalidaActivo:any;	
    public sede:string;
    public idVisita:string;

    constructor(hisActivoFijoVisitantePK: HisActivoFijoVisitantePK){
        this.hisActivoFijoVisitantePK=hisActivoFijoVisitantePK;
    }
}

export class HisActivoFijoVisitantePK {
    public idActivoFijoVisitante:number;
    public fechaIngresoActivo:any;

    constructor() { }
}

